import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearFiles } from 'app/store/slices/forms';
import {
  fetchSubSystems,
  fetchVehicleTypes,
  fetchAccessibilityType,
  fetchFuelType,
  fetchVehicleClassification,
  fetchVehicleCategories,
  fetchVehicleModels,
  fetchVehicleBrands,
} from 'app/store/slices/vehicle';

const withVehicleInitialization = BaseComponent => props => {
  const dispatch = useDispatch();

  const [initialLoading, setInitialLoading] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [vehicleSelected, setVehicleSelected] = useState({});

  const vehicleType = useSelector(state => state.vehicle.vehicleType);
  const vehicleCategories = useSelector(state => state.vehicle.vehicleCategories);
  const accessibilityType = useSelector(state => state.vehicle.accessibilityType);
  const fuelType = useSelector(state => state.vehicle.fuelType);
  const vehicleClassification = useSelector(state => state.vehicle.vehicleClassification);
  const vehicleModels = useSelector(state => state.vehicle.vehicleModels);
  const vehicleBrands = useSelector(state => state.vehicle.vehicleBrands);
  const subSystems = useSelector(state => state.vehicle.subSystems);

  useEffect(() => {
    const init = async () => {
      setInitialLoading(true);
      const promisses = [];
      if (vehicleType.length === 0) promisses.push(dispatch(fetchVehicleTypes()));
      if (vehicleCategories.length === 0) promisses.push(dispatch(fetchVehicleCategories()));
      if (accessibilityType.length === 0) promisses.push(dispatch(fetchAccessibilityType()));
      if (vehicleModels.length === 0) promisses.push(dispatch(fetchVehicleModels()));
      if (vehicleBrands.length === 0) promisses.push(dispatch(fetchVehicleBrands()));
      if (fuelType.length === 0) promisses.push(dispatch(fetchFuelType()));
      if (vehicleClassification.length === 0)
        promisses.push(dispatch(fetchVehicleClassification()));
      if (subSystems.length === 0) promisses.push(dispatch(fetchSubSystems()));
      if (promisses.length > 0) await Promise.all(promisses);
      setInitialLoading(false);
    };
    init();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const reset = () => {
    dispatch(clearFiles());
    onCloseDrawer();
    setVehicleSelected({});
  };

  const onCancel = () => {
    reset();
  };

  const onCloseDrawer = () => {
    setVehicleSelected({});
    setOpenDrawer(false);
  };

  return (
    <BaseComponent
      {...props}
      initialLoading={initialLoading}
      setInitialLoading={setInitialLoading}
      openDrawer={openDrawer}
      setOpenDrawer={setOpenDrawer}
      vehicleSelected={vehicleSelected}
      setVehicleSelected={setVehicleSelected}
      reset={reset}
      onCancel={onCancel}
      onCloseDrawer={onCloseDrawer}
    />
  );
};

export default withVehicleInitialization;
